import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-to-hit-threshold',
  templateUrl: './time-to-hit-threshold.component.html',
  styleUrls: ['./time-to-hit-threshold.component.css']
})
export class TimeToHitThresholdComponent implements OnInit {

  @Input() entityDetails: any;
  @Input() widgetData: any;
  @Input() entityId: string;
  
  constructor() { }

  ngOnInit(): void {
  }

}
